

export const getConsentUrl = (tenantId?: string, clientId?: string): string => {
    const redirectUrl = `${window.location.origin}/consent-redirect.html`;
    return `${window.location.origin}/consent-start.html?tenant_id=${tenantId}&client_id=${clientId}&redirect_uri=${redirectUrl}`;
}